﻿import CompactSearchPage from "../compactSearchPage";

export default class PatentWatch extends CompactSearchPage {

    constructor() {
        super();
        this.tabsLoaded = [];
    }

    onSearchInitialized = () => {
        $("#patentWatchContainer").append($(`${this.searchResultGrid}_pager`));
        $("#patentWatchUpdatesContainer").append($("#patentWatchUpdates-Grid_pager"));

        $(document).ready(() => {
            const grid = $(this.searchResultGrid);
            const listView = grid.data("kendoListView");

            $("#patentWatchTable").find(".k-link").sorter(listView, true);

            grid.on("click", ".pw-ls-toggle", (e) => {
                this.getLegalStatusEvents(e);
            });
            $("#patentWatchUpdates-Grid").on("click", ".pw-ls-toggle", (e) => {
                this.getLegalStatusEvents(e);
            });

            $("#pw-Watch").on("change", (e) => {
                if ($(e.target).is(":checked"))
                    $(".users-to-notify").removeClass("d-none");
                else
                    $(".users-to-notify").addClass("d-none");
            });
            
            this.exportToExcelHandler();
            this.tabChangeSetListener();
        });
        this.editableGrids = [{ name: "usersToNotifyGrid"}];
    }

    tabChangeSetListener = () => {
        $("#patent-watch-results a").on("click", (e) => {
            e.preventDefault();
            const tab = $(e.target).attr("aria-controls");
            if (this.tabsLoaded.indexOf(tab) === -1) {
                this.tabsLoaded.push(tab);

                if (tab === "watchList") {
                    const grid = $("#patentWatchList-Grid").data("kendoGrid");
                    grid.dataSource.read();
                }
                else if (tab === "watchResults") {
                    this.loadWatchUpdates();
                }
            }
        });
    }

    loadWatchUpdates = () => {
        $(document).ready(() => {
            const grid = $("#patentWatchUpdates-Grid").data("kendoListView");
            grid.dataSource.read();
        });
    }

    getLegalStatusEvents = (e) => {
        const element = e.target;
        const lsContainer = $(element.parentNode).siblings(".pw-ls-container");

        if (element.className.includes("plus")) {
            element.className = element.className.replace("plus", "minus");

            if (!lsContainer.hasClass("mounted")) {
                const header = $(element).data("ifd-header");
                this.getLSDEvents(header, lsContainer);
            }
            else
                lsContainer.show();
        }
        else {
            element.className = element.className.replace("minus", "plus");
            lsContainer.hide();
        }
    }

    //onSearchSubmit = () => {
    //    const searchForm = $(`${this.searchForm}`);
    //    const watch = searchForm.find("input[name='Watch']").prop("checked");

    //    if (watch) {
    //        const numbers = searchForm.find("textarea[name='Numbers']").val();
    //        const exceededError = searchForm.find("#field-validation-numbers-exceed");
    //        const count = numbers.split(";").length;

    //        const watchList = $("#patentWatchList-Grid").data("kendoGrid");
    //        const existing = watchList.dataSource.data();

    //        if (existing.length + count > 150) {
    //            exceededError.removeClass("d-none");
    //            return false;
    //        }
    //        else {
    //            exceededError.addClass("d-none");
    //            return true;
    //        }
    //    }
    //    return true;
    //}

    exportToExcelHandler() {
        $("#pwExportExcel").on("click", ()=> {

            const baseUrl = $("body").data("base-url");
            const url = `${baseUrl}/Patent/PatentWatch/ExportToExcel`;

            const source = pageHelper.formDataToJson($(`${this.searchForm}`));
            const form = $("#pwExportExcelForm");
            form.attr("action", url);
            form.find("input[name='NumberType']").val(source.payLoad.NumberType);
            form.find("input[name='Numbers']").val(source.payLoad.Numbers);
            form.submit();
        });
    }

    //onGridDataBound = () => {
    //    const grid = $(this.searchResultGrid).data("kendoGrid");
    //    const foundData = grid.dataSource.data();

    //    const searchNos = $("#patentWatchSearchMainTabContent").find("#Numbers").val().split(";");
    //    const notFound = searchNos.filter(no => !foundData.find(f => f.SearchNo === no));
    //    $("#patentWatchSearch").find("#recordsNotFound textarea").text(notFound.join(";"));

    //    $(this.searchResultGrid).on("click", ".pw-ls-toggle", (e) => {
    //        const element = e.target;
    //        const lsContainer = $(element.parentNode).siblings(".pw-ls-container");

    //        if (element.className.includes("plus")) {
    //            element.className = element.className.replace("plus", "minus");

    //            if (!lsContainer.hasClass("mounted")) {
    //                const header = $(element).data("ifd-header");
    //                this.getLSDEvents(header, lsContainer);
    //            }
    //            else
    //                lsContainer.show();
    //        }
    //        else {
    //            element.className = element.className.replace("minus", "plus");
    //            lsContainer.hide();
    //        }
    //    });


    //    //var dataSource = new kendo.data.DataSource({
    //    //    data: notFound
    //    //});
    //    //var notFoundGrid = $("#patentWatchSearch").find("#notFoundGrid").data("kendoGrid");
    //    //notFoundGrid.setDataSource(dataSource);
    //    //notFoundGrid.refresh();
    //}

    getLSDEvents(header, lsContainer) {
        const baseUrl = $("body").data("base-url");
        const url = `${baseUrl}/Patent/PatentWatch/GetLSDEvents`;

        $.get(url, { header: header })
            .done((result) => {

                //const id = header.split(" ");
                //const recId = id[id.length - 1].replaceAll(" ", "");

                const recId = header.replaceAll(" ", "");
                result = result.replaceAll("patentWatchLSDEvents-Grid", `patentWatchLSDEvents-Grid_${recId}`);
                lsContainer.html(result);
                lsContainer.addClass("mounted");
            })
            .fail((e => {
                pageHelper.showErrors(e);
            }));
    }

    dataBound=()=> {
        let highlightRow = 4;
        $(this.searchResultGrid).find("tr").each(function (index) {
            const row = index + 1;
          
            if (row >= highlightRow && row <= highlightRow + 2) {
                $(this).addClass("altItem");

                if (row === highlightRow + 2)
                    highlightRow = highlightRow + 6;
            }
        });
        const watchList = $("#patentWatchList-Grid").data("kendoGrid");
        watchList.dataSource.read();

        //for the notfound list
        const grid = $(this.searchResultGrid).data("kendoListView");
        const foundData = grid.dataSource.data();
        const searchForm = $(`${this.searchForm}`);
        const searchNos = searchForm.find("textarea[name='Numbers']").val().split(";");
        const notFound = searchNos.filter(no => !foundData.find(f => f.SearchNo === no));
        $("#patentWatchSearch").find("#recordsNotFound textarea").text(notFound.join(";"));
       
    }
    deleteGridRow(e, grid) {
        const dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
        pageHelper.kendoGridDeleteRecord(e, dataItem);
        
    }

    usersToNotify(e, grid) {
        const dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
        const baseUrl = $("body").data("base-url");
        const url = `${baseUrl}/Patent/PatentWatch/GetUsersToNotify`;

        $.get(url, { watchId: dataItem.WatchId}).done((result) => {
            $(".cpiContainerPopup").empty();
            const popupContainer = $(".cpiContainerPopup").last();
            popupContainer.html(result);
            const dialog = $("#saveUsersToNotifyDialog");
            dialog.modal("show");
            //dialog.floatLabels();

            //let entryForm = dialog.find("form")[0];
            //entryForm = $(entryForm);

            //entryForm.cpiPopupEntryForm(
            //    {
            //        dialogContainer: dialog,
            //        afterSubmit: function () {
            //            dialog.modal("hide");
            //        }
            //    }
            //);

            this.editableGrids.forEach((el) => {
                const grid = $(`#${el.name}`);
                pageHelper.kendoGridDirtyTracking(grid, el);
            });

        }).fail(function (error) {
            pageHelper.showErrors(error.responseText);
        });
    }

    

}





